import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon, GiftIcon, ArrowRightIcon } from "lucide-react";
import { goToCheckout, PRICE } from "../src/config";
export function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem("bsm_exit_shown")) {
      setDismissed(true);
      return;
    }
    const trigger = () => {
      if (!sessionStorage.getItem("bsm_exit_shown")) {
        setOpen(true);
        sessionStorage.setItem("bsm_exit_shown", "1");
      }
    };
    const onMouseOut = (e: MouseEvent) => {
      if (e.clientY <= 0) trigger();
    };

    // Desktop exit-intent
    document.addEventListener("mouseout", onMouseOut);
    // Mobile fallback: fire after a delay
    const t = setTimeout(trigger, 25000);
    return () => {
      document.removeEventListener("mouseout", onMouseOut);
      clearTimeout(t);
    };
  }, []);
  if (dismissed) return null;
  return <AnimatePresence data-id="element-73" data-mp="2j2i2qqsnsb7x">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm" onClick={() => setOpen(false)} role="dialog" aria-modal="true" aria-label="Oferta especial antes de salir" data-id="element-74" data-mp="2o3xka8vmnzlk">
          <motion.div initial={{
        scale: 0.9,
        y: 20,
        opacity: 0
      }} animate={{
        scale: 1,
        y: 0,
        opacity: 1
      }} exit={{
        scale: 0.9,
        y: 20,
        opacity: 0
      }} transition={{
        type: "spring",
        stiffness: 300,
        damping: 26
      }} onClick={e => e.stopPropagation()} className="relative w-full max-w-md overflow-hidden rounded-3xl border border-violet-500/30 bg-[#0d0b22] p-8 text-center shadow-2xl" data-id="element-75" data-mp="255bj6u0428hn">
            <button onClick={() => setOpen(false)} aria-label="Cerrar" className="absolute right-4 top-4 text-slate-400 transition-colors hover:text-white" data-id="element-76" data-mp="1lix0910h866e">
              <XIcon className="h-5 w-5" data-id="element-77" data-mp="3jay93ekz0rg4" />
            </button>

            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-300" data-id="element-78" data-mp="3ee7pwidvdfqh">
              <GiftIcon className="h-7 w-7" data-id="element-79" data-mp="39cqswxyiadf6" />
            </div>

            <h3 className="mt-4 font-display text-2xl font-extrabold text-white" data-id="element-80" data-mp="awfsupkvm5lf">
              ¡Espera! No te vayas con las manos vacías
            </h3>
            <p className="mt-3 text-slate-300" data-id="element-81" data-mp="yi6k7mkuivg">
              Estás a un clic de facturar en dólares. Llévate el sistema completo
              + los 5 bonos por solo{" "}
              <span className="font-bold text-emerald-400" data-id="element-82" data-mp="3t4x5dwyd5h05">{PRICE}</span> — el
              precio de un café.
            </p>

            <button onClick={goToCheckout} className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-emerald-500 px-6 py-4 font-display font-extrabold uppercase text-emerald-950 transition-colors hover:bg-emerald-400" data-id="element-83" data-mp="2hnnq7mm9pb4n">
              Sí, quiero mi acceso
              <ArrowRightIcon className="h-5 w-5" data-id="element-84" data-mp="165t4alqx9vzd" />
            </button>
            <button onClick={() => setOpen(false)} className="mt-3 text-xs text-slate-500 underline-offset-2 hover:underline" data-id="element-85" data-mp="1awrohwf17e7w">
              No gracias, prefiero seguir cobrando en pesos
            </button>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}